module.exports = __webpack_public_path__ + "static/media/background.384d32ce.jpg";